const IP_HOSTNAME_PATTERN = /^[0-9.]+$/;

export function deriveBaseHostname(hostnames: string[]): string | null {
  for (const host of hostnames) {
    if (host === "localhost" || IP_HOSTNAME_PATTERN.test(host)) continue;
    const labels = host.split(".");
    if (labels.length >= 2) return labels.slice(-2).join(".");
  }
  return null;
}
